import FaqAccordion from "../../components/sections/FaqAccordion";
import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "Starter", desc: "5–8 pages, responsive, basic SEO, and a fast 2-week delivery path." },
  { title: "Professional", desc: "CMS support, e-commerce readiness, advanced SEO, and a polished custom build." },
  { title: "Enterprise", desc: "Custom development, API integrations, and larger-scale delivery for complex business needs." },
];

const faqs = [
  { question: "Do you use templates?", answer: "No. Every design starts from scratch in Figma." },
  { question: "Who owns the website?", answer: "You do. Full IP transfer on delivery." },
  { question: "Can you redesign an existing site?", answer: "Yes. Redesigns start from ₹20,000." },
];

const packageRows = [
  ["Starter", "₹25,000–₹50,000", "5–8 pages, responsive, basic SEO", "2 weeks"],
  ["Professional", "₹50,000–₹1,50,000", "CMS, e-commerce ready, advanced SEO", "4–6 weeks"],
  ["Enterprise", "₹1,50,000+", "Custom development, API integrations", "8+ weeks"],
];

const WebDevelopment = () => (
  <StitchFeaturePage
    label="SERVICE · WEB DEVELOPMENT"
    title="Your digital"
    titleAccent="presence, built right."
    subtitle="From 5-page business websites to full-stack web applications — designed to convert, built to perform, handed over with full ownership."
    features={features}
    ctaLabel="START YOUR WEB PROJECT"
  >
    <div style={{ display: "grid", gap: 28 }}>
      <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: "28px clamp(20px, 4vw, 30px)" }}>
        <SectionLabel text="PACKAGES" />
        <div style={{ overflowX: "auto", marginTop: 20 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 640 }}>
            <thead>
              <tr>
                {["Package", "Price", "Includes", "Timeline"].map((heading) => (
                  <th key={heading} style={{ textAlign: "left", padding: "14px 0", borderBottom: "1px solid rgba(212,168,67,0.18)", fontFamily: "'Barlow Condensed', sans-serif", fontSize: 12, letterSpacing: "0.18em", color: "#D4A843", textTransform: "uppercase" }}>{heading}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {packageRows.map((row) => (
                <tr key={row[0]}>
                  {row.map((cell) => (
                    <td key={cell} style={{ padding: "16px 0", borderBottom: "0.5px solid rgba(212,168,67,0.12)", fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC" }}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ background: "#1A1208", border: "1px solid rgba(212,168,67,0.22)", borderRadius: 4, padding: 24, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.8 }}>
        Included in all packages: Custom responsive design · Mobile-first · On-page SEO · GA4 + Search Console setup · Contact forms · SSL + CDN + daily backups · 45-day post-launch support
      </div>

      <div>
        <SectionLabel text="FAQ" />
        <div style={{ marginTop: 20 }}>
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </div>
  </StitchFeaturePage>
);

export default WebDevelopment;
